import { FamilyMember, FamilyMemberId } from '../engine/types';

// The cast. Bios introduce the family before the outage; verdict lines are their
// closing judgment of your blackout parenting. Keep each member's voice (see README
// voice spec): Sam warm and wry, Riley dry teen, Jojo excitable kid. No emoji.
export const FAMILY: Record<FamilyMemberId, FamilyMember> = {
  jojo: {
    bio: 'The little one. Powered by snacks, movies, and asking at the exact wrong time.',
    id: 'jojo',
    initial: 'J',
    name: 'Jojo',
    role: 'the kid',
    verdicts: {
      denied: 'zero cocoa. zero movies. writing ALL of this in my memoirs',
      granted: 'BEST. BLACKOUT. EVER. can we do another one tomorrow??',
      mixed: 'pretty fun!! except the parts that were extremely not',
      special: 'the fridge smells like a science fair. i am never opening it again',
    },
  },
  riley: {
    bio: 'Resident teen. Runs on Wi-Fi, video games, and righteous indignation.',
    id: 'riley',
    initial: 'R',
    name: 'Riley',
    role: 'the teen',
    verdicts: {
      denied: 'no games. no hot breakfast. survived on vibes and granola bars. never forget',
      granted: 'screen time AND hot food during a blackout? best parenting on record',
      mixed: 'honestly? mid. some wins, some crimes against wifi',
      special: 'you cut the WIFI. on PURPOSE. my streaks are gone and so is my trust',
    },
  },
  sam: {
    bio: 'Your partner. At work all day, checking the thermostat from afar all night.',
    id: 'sam',
    initial: 'S',
    name: 'Sam',
    role: 'your partner',
    verdicts: {
      denied: 'Cold dinners and a colder house. Next outage, I vote we defect to the neighbors.',
      granted: 'Hot meals, clean laundry, warm house. You can run my grid anytime.',
      mixed: 'Solid crisis management. Some sacrifices were made. I’m choosing not to name them.',
      special: 'The WHOLE house went dark. I am framing this as a character-building exercise for the kids.',
    },
  },
};

/** family order for display: partner first, then kids by age */
export const FAMILY_ORDER: FamilyMemberId[] = ['sam', 'riley', 'jojo'];

/** look a member up from a chat sender name ('Sam' → sam); system senders return undefined */
export const familyMemberByName = (name: string): FamilyMember | undefined =>
  Object.values(FAMILY).find((member) => member.name === name);
